import React, { forwardRef, useEffect, useMemo } from 'react';
import { useIdle, usePreviousDistinct } from 'react-use';

import { AvailabilityProps } from '.';
import { AvailabilityCalendar } from './AvailablilityCalendar';
import { NonSpecificAvailability } from './NonSpecificAvailability';
import { isDoctorVirtualGp } from 'src/utils/doctor';

export const Availability = forwardRef<HTMLDivElement, AvailabilityProps>(
    (
        {
            doctorId,
            appointmentType,
            clinicId,
            onSelectTimeSlot,
            disabled,
            errorElement,
            futureApptWeeks,
            allUsers,
            isLoadingFirstAvailable,
            refreshAvailability,
            firstAvailableDate,
        },
        ref
    ) => {
        const isIdle = useIdle(60e3, false);
        const wasIdle = usePreviousDistinct(isIdle);
        useEffect(() => {
            if (!isIdle && wasIdle) {
                refreshAvailability?.();
            }
        }, [isIdle, wasIdle, refreshAvailability]);

        const isVirtual = useMemo(() => {
            const dr = allUsers?.find((dr) => dr.userId === doctorId?.toString());
            return dr && isDoctorVirtualGp(dr);
        }, [allUsers, doctorId]);

        return (
            <div ref={ref}>
                {isVirtual ? (
                    <NonSpecificAvailability
                        appointmentType={appointmentType}
                        clinicId={clinicId}
                        doctorId={doctorId}
                        disabled={disabled}
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onSelectTimeSlot={onSelectTimeSlot as any}
                        firstAvailableDate={firstAvailableDate}
                        firstAvailableIsLoading={isLoadingFirstAvailable}
                        errorElement={errorElement}
                        futureApptWeeks={futureApptWeeks}
                        allUsers={allUsers}
                        infoText={
                            <>
                                <strong className="font-semibold">Please note:</strong> This is a request for a same-day
                                telehealth call. A doctor will contact you once they become available.
                            </>
                        }
                    />
                ) : (
                    <AvailabilityCalendar
                        appointmentType={appointmentType}
                        clinicId={clinicId}
                        doctorId={doctorId}
                        disabled={disabled}
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        onSelectTimeSlot={onSelectTimeSlot as any}
                        firstAvailableDate={firstAvailableDate}
                        firstAvailableIsLoading={isLoadingFirstAvailable}
                        errorElement={errorElement}
                        futureApptWeeks={futureApptWeeks}
                        allUsers={allUsers}
                    />
                )}
            </div>
        );
    }
);
